/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Back_To_ListInputs */



/**
* | output |
* | --- |
* | "Back to leagues" |
*
* @param {League_Back_To_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_back_to_list = /** @type {((inputs?: League_Back_To_ListInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Back_To_ListInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour aux ligues")
	if (locale === "es") return /** @type {LocalizedString} */ ("Volver a las ligas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Voltar para as ligas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna ai campionati")
	return /** @type {LocalizedString} */ ("Back to leagues")
});